import React, { useEffect } from 'react';
//componets
import FlNav from './landingComponents/Navbar';
import FlFooter from './landingComponents/Footer';

//Mansory - Bento grid
import Masonry from 'react-masonry-css';

import fondo from '../../assets/img/landingPage/fondo.png';
import icon_01 from '../../assets/img/landingPage/interpreter/avap-inter_01_speed.svg'
import icon_02 from '../../assets/img/landingPage/cloudP/icn_cloudP_07.png'
import icon_03 from '../../assets/img/landingPage/connectors/connectors_01_data.svg'
import icon_04 from '../../assets/img/landingPage/university/university_01.png'

import insignia_01 from '../../assets/img/landingPage/connect/Insignias-advisor.png'
import insignia_02 from '../../assets/img/landingPage/connect/Insignias-integrator.png'
import insignia_03 from '../../assets/img/landingPage/connect/Insignias-developer.png'
import insignia_04 from '../../assets/img/landingPage/connect/Insignias-vendor.png'

import fundaciones from '../../assets/img/landingPage/connect/logos-fundaciones.png'

import features_1 from '../../assets/img/landingPage/connect/Connect01.png'
import features_2 from '../../assets/img/landingPage/connect/Connect02.png'
import features_3 from '../../assets/img/landingPage/connect/Connect03.png'
import features_4 from '../../assets/img/landingPage/connect/Connect04.png'
import features_5 from '../../assets/img/landingPage/connect/Connect05.png'
import features_6 from '../../assets/img/landingPage/connect/Connect06.png'

import logo from '../../assets/img/logos/AVAPConnect-negativo.svg'
import dividerbg from '../../assets/img/landingPage/hexagono-horizonte.png'

import gradientbottom from '../../assets/img/landingPage/gradientbottom.png'

import Favicon from '../../assets/img/Favicon_AVAP_Framework.png'

const Connect = () => {

    useEffect(() => {
        // favicon 
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = Favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);

        // clean favicon 
        return () => {
            document.head.removeChild(link);
        };
    }, []);


    useEffect(() => {

        document.body.classList.add('dark-bg');
        return () => {
            document.body.classList.remove('dark-bg');
        };

    }, []);
    //Key UseCases Bento
    const items2 = [
        {
            icon: insignia_01,
            title: 'Solution Advisor',
            paragraphs: [
              'Trusted technology consultant, dedicated to helping companies uncover and address strategic challenges using AVAP technology. With a focus on thorough analysis and process optimization, they deliver objective recommendations, supported by a team of certified experts and advanced solutions consultants.'
            ]
          },
        {
            icon: insignia_02,
            title: 'System Integrator',
            paragraphs: [
              "Expert partners dedicated to implementing and enhancing AVAP-based solutions, enabling the smooth integration of new functionalities within their clients' existing systems."
            ]
          },
        {
          icon: insignia_03,
          title: 'Certified Developer',
          paragraphs: [
            'Key partner who, using AVAP technology, develops tailored, custom solutions for each client. These developers are highly skilled at adapting and maximizing the value of AVAP technology, ensuring that each solution meets the specific requirements and business objectives of every client.',
          ]
        },
        {
            icon: insignia_04,
            title: 'Solution Vendor',
            paragraphs: [
              'Key partner that markets solutions built on AVAP technology or develops proprietary products leveraging this platform for commercialization. By offering customers customized and optimized technologies, this partner enhances the reach of AVAP Framework solutions, addressing diverse business and market needs while facilitating the seamless adoption of innovative solutions.',
            ]
          },         
      ];
      
    const breakpointColumnsObj2 = {
        default: 2, //Cambio de columnas verticales
        1100: 2,
        700: 1          
    };
    

    return (
        <>
            <FlNav></FlNav>
            <div id="pricing"
            className="fl-cloud-product bg-black text-white"
            style={{ backgroundImage: `url(${fondo})` }}>
               
                {/* Hero Section */}
                <section id="heroProduct" className="text-center pt-5">
                    <img
                        src={logo}
                        alt="Logo AVAP Marketplace"
                        className="img-fluid logo"
                    />
                    <h1 className="fl-title m-0">Grow with AVAP Connect</h1>
                    <p className="fl-subtitle">
                        Partner with a platform built to power the full API lifecycle
                    </p>
                    <p className='fl-txt-container'>
                        Join a global network of innovators who provide, build, integrate, and deliver next-gen API lifecycle solutions using AVAP Framework.
                    </p>
                    {/*Boton Formulario*/}  
                        <a 
                        className="glowBtn aling-center" 
                        style={{ zIndex: 2 }} 
                        href="/connect-form">
                        <span className="btnInner"> Become a Partner </span>
                        </a>
                </section>


                {/* About AVAP Connect */}
                <section className="container text-center pb-5 pt-8">
                    <div className="row">
                        <div className="col">
                            {/* <img
                                src="https://placehold.co/1026x423"
                                alt="Platform Placeholder"
                                className="img-fluid mt-4 mb-5"
                            /> */}
                            <p className="fl-title mb-3 gradient-text">
                                About AVAP Connect
                            </p>
                             <p className="fl-subtitle mb-3 fl-txt-container-s ">
                                AVAP Connect is more than a partner program, it’s a global technology ecosystem
                            </p>
                            <p className="fl-text fl-txt-container-s">
                                Designed for solution providers, integrators, consultants, and developers, AVAP Connect gives you access to a complete API lifecycle management platform, sales tools, technical support, and co-marketing opportunities, all under one unified framework.
                            </p>
                              <p className="fl-subtitle-xs fl-txt-container-s pt-4">
                                By joining, you’ll be able to:
                            </p>
                        </div>
                    </div>
                </section>

                {/* Features */}
                <section className="container pb-5 text-center">
                    <div className="row">
                        <div className="col-md-3">
                            <div className="fl-pill-2">
                                <img src={icon_01} alt="Icon representing a three-layered infrastructure with stacked horizontal layers." />
                                <p className='fl-fw-semibold'>Build and launch scalable, competitive API solutions with AVAP technology.</p>
                            </div>
                        </div>
                        <div className="col-md-3 text-center">
                            <div className="fl-pill-2">
                                <img src={icon_02} alt="Icon representing a three-layered infrastructure with stacked horizontal layers." />
                                <p className="text-center fl-fw-semibold">Sell and integrate AVAP products, services and solutions across industries.</p>
                            </div>
                        </div>
                        <div className="col-md-3 text-center">
                            <div className="fl-pill-2">
                                <img src={icon_03} alt="Icon representing a three-layered infrastructure with stacked horizontal layers." />
                                <p className="text-center fl-fw-semibold">Expand your business with new revenue streams.
                                
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3 text-center">
                            <div className="fl-pill-2">
                               <img src={icon_04} alt="Icon representing a three-layered infrastructure with stacked horizontal layers." />
                                <p  className="text-center fl-fw-semibold">Collaborate with a fast-growing community of forward-thinking partners.</p>
                            </div>
                        </div>
                    </div>
                    <p className="fl-subtitle-xs fl-txt-container-s pt-4 gradient-text">
                        Whether you're offering consulting services, developing custom solutions, or scaling infrastructure solutions, AVAP Connect empowers you to deliver more, faster.
                    </p>
                </section>

                {/* Partner Benefits */}
                <div>
                    <h1 className="fl-title text-center pt-8">Partner Benefits</h1>
                    <p className="fl-text fl-txt-container-s text-center pb-6">
                     Being part of AVAP Connect means more than accessing cutting-edge technology, it’s opening the door to new business opportunities and strengthening your position in the tech market.

                    </p>
                </div>

                 {/* Partner Benefits - ExclusiveTools */}
                <section className="container py-5 gradient-d fl-br-20 mb-5">
                    
                    <div className="row align-items-center">
                            <div className="col-md-6 pl-5">
                            <span className="fl-label">Partner Benefits</span>
                            <h3 className="fl-title">Exclusive Tools Access</h3>
                            <ul>
                                <li className="fl-text fl-bullets-benefits">Expert technical support to accelerate your projects</li>
                                <li className="fl-text fl-bullets-benefits">Interactive demos to showcase impactful solutions</li>
                                <li className="fl-text fl-bullets-benefits">Webinars and events to stay updated with the latest innovations</li>
                            </ul>
                        </div>
                        <div className="col-md-6 text-center">
                            <img
                                src={features_1}
                                alt="Illustration of three API product cards"
                                className="img-fluid"
                                style={{ maxWidth: '80%'}}
                            />
                        </div>
                  
                    </div>
                </section>
                
                {/* Partner Benefits - Visibility and Recognition */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 text-center">
                            <img
                                src={features_2}
                                alt="Illustration of AVAP Marketplace icon and pricing options including monthly and annual subscriptions."
                                className="img-fluid"
                                style={{ maxWidth: '80%'}}
                            />
                        </div>
                             <div className="col-md-6 pr-5">
                            <span className="fl-label">Partner Benefits</span>
                            <h3 className="fl-title">Visibility and Recognition</h3>
                             <ul className="fl-text">
                                <li className="fl-text fl-bullets-benefits">Inclusion in our global partner directory to attract more clients</li>
                                <li className="fl-text fl-bullets-benefits">Co-branding opportunities to boost your brand presence</li>
                                <li className="fl-text fl-bullets-benefits">Prominent exposure across AVAP’s communication channels</li>
                            </ul>
                        </div>
                    </div>
                </section>

                {/* Partner Benefits - Business Opportunities */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Partner Benefits</span>
                            <h3 className="fl-title">Business Opportunities</h3>
                            <ul className="fl-text">
                                <li className="fl-text fl-bullets-benefits">Priority access to innovative solutions within the AVAP ecosystem</li>
                                <li className="fl-text fl-bullets-benefits">Participation in strategic projects and exclusive pilots</li>
                            </ul>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_3}
                                alt="Illustration of AVAP Marketplace interface displaying a developer profile with API product listings."
                                className="img-fluid"
                                style={{ maxWidth: '80%'}}
                            />
                        </div>
                    </div>
                </section>
                
                {/* Partner Benefits - Training and Certifications */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 text-center">
                            <img
                                src={features_4}
                                alt="Illustration of AVAP Marketplace interface displaying a developer profile with the certification process."
                                className="img-fluid"
                                style={{ maxWidth: '80%'}}
                            />
                        </div>
                        <div className="col-md-6 pr-5">
                            <span className="fl-label">Partner Benefits</span>
                            <h3 className="fl-title">Training and Certifications</h3>
                            <ul className="fl-text">
                                <li className="fl-text fl-bullets-benefits">Specialized training to master AVAP technology</li>
                                <li className="fl-text fl-bullets-benefits">Official certifications to validate your skills and enhance your professional profile</li>
                            </ul>
                        </div>

                    </div>
                </section>

                {/* Partner Benefits - Support and Guidance */}
                <section className="container py-5 gradient-d fl-br-20 mt-5 mb-5 pb-4">
                    <div className="row align-items-center">
                        <div className="col-md-6 pl-5">
                            <span className="fl-label">Partner Benefits</span>
                            <h3 className="fl-title">Support and Guidance</h3>
                            <ul className="fl-text">
                                <li className="fl-text fl-bullets-benefits">Personalized advisory to maximize the value of the partnership</li>
                                <li className="fl-text fl-bullets-benefits">Access to success stories and best practices to inspire and guide your growth</li>
                            </ul>
                        </div>

                        <div className="col-md-6 text-center">
                            <img
                                src={features_5}
                                alt="Illustration of AVAP Marketplace interface displaying a developer profile with API product listings."
                                className="img-fluid"
                                style={{ maxWidth: '80%'}}
                            />
                        </div>
                    </div>
                </section>

                 {/*Boton Formulario*/}  
                        <a 
                        className="glowBtn aling-center" 
                        style={{ zIndex: 2 }} 
                        href="/connect-form">
                        <span className="btnInner"> Become a Partner </span>
                        </a>

                {/*Partnership Models */}
                <div className="container my-5 pt-6">
                <div className="fl-title text-center mb-2">
                    Partnership Models
                </div>
                <p className='fl-subtitle-xs text-center fl-txt-container-s pb-4'>AVAP Connect offers four partner types, tailored to different business models to help you maximize impact and growth potential.</p>

                    <Masonry
                        breakpointCols={breakpointColumnsObj2}
                        className="masonry-grid"
                        columnClassName="masonry-column"
                        >
                        {items2.map((item2, idx) => (
                            <div key={idx} className="grayBox fl-card text-center">
                            <img src={item2.icon} alt="Icon representing 0X" className="Insignias" />
                            <p className="fl-subtitle-xs">{item2.title}</p>
                            {item2.paragraphs.map((p, i) => (
                            <p key={i} className="fl-text">{p}</p>
                            ))}
                            </div>
                        ))}
                    </Masonry>
                      {/*Boton Formulario*/}  
                        <a 
                        className="glowBtn aling-center" 
                        style={{ zIndex: 2 }} 
                        href="/connect-form">
                        <span className="btnInner"> Become a Partner </span>
                        </a>
                </div>

                {/* Ready to scale with us? */} 
                <section className="container">
                    <div className="row">
                        <div className="col">
                            <div className="blobContainer mb-8 mt-4 text-center">

                                <div className="blob"></div>
                                <div className="">
                                    <h3 className='fl-title'>Ready to scale with us?</h3>
                                    <p>Join a global ecosystem of innovators building the future of APIs. Whether you're advising clients, integrating systems, developing custom solutions, or bringing products to market, AVAP Connect gives you the tools, support, and visibility to go further. Let’s grow together.
                                    </p>
                                <img
                                src={fundaciones}
                                alt="Illustration of AVAP Marketplace interface displaying a developer profile with API product listings."
                                className="img-fluid pt-6"
                                style={{ maxWidth: '50%'}}
                                />
                                
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            
               


                {/* Getting Started */}
                <div className="bottomWrapper position-relative d-flex justify-content-center">
                    <img src={gradientbottom} alt="" className="gradient gradientBottom" />
                </div>
            </div>
            <FlFooter></FlFooter>
        </>
    );
};

export default Connect;
